export const topUpStatus = [
  'Hold',
  'Sent',
  'Processing',
  'Pending',
  'Success',
  'Failed',
  'Revoked',
  'Canceled',
]
